import { InputHtmlProps, ObjectValues } from '../types';
import { Messages } from '../use-input-validation.types';

export const themes = {
  dark: 'dark',
  light: 'light',
} as const;

export const variants = {
  small: 'small',
  large: 'large',
};

export type TextInput = {
  customErrorMessages?: Messages;
  hasError?: boolean;
  hasMovingLabel?: boolean;
  helpText?: string;
  hiddenLabel?: boolean;
  icon?: React.ReactNode;
  label: string;
  name: string;
  theme?: ObjectValues<typeof themes>;
  variant?: ObjectValues<typeof variants>;
} & InputHtmlProps;
